;(function (window, document) {

	'use strict'

	function copyUrlInit() {
		var copyURLBtn = document.querySelector('.js-url-copy-btn');

		copyURLBtn.addEventListener('click', function (event) {
			navigator.clipboard.writeText(window.location.href);
		});
	}

	// Start Animations when the page is ready.
	window.addEventListener('DOMContentLoaded', () => {
		if ( document.querySelector('.js-url-copy-btn') ) {
			copyUrlInit();
		}
	})

})(window, document)